export default __webpack_public_path__ + "static/media/Car-PO.7b3fe6f2.webp";